'use strict';

var React = require('react');

var AggregatedItems = React.createClass({
    shouldComponentUpdate: function() {
        return false;
    },

    renderItem: function(item) {
        return (
            <li key={item.content.title} className="aggregated-item">
                <a classNames="aggregated-link" href={item.content.url}>
                    <p className='gui-color-primary aggregated-item-text'>{item.content.title}</p>
                </a>
            </li>
        );
    },

    render: function() {
        var items = [];

        for (var i = 0; i < this.props.items.length; i++) {
            items.push(this.renderItem(this.props.items[i], i));
        }

        return (
            <ul className="aggregated-items">
                {items}
            </ul>
        );
    }
});

module.exports = AggregatedItems;
